<template>
  <svg
    width="82"
    height="44"
    viewBox="0 0 82 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 1C20 0.447715 20.4477 0 21 0H61C61.5523 0 62 0.447715 62 1V11C62 11.5523 61.5523 12 61 12H21C20.4477 12 20 11.5523 20 11V1Z"
    />
    <path
      d="M20 17C20 16.4477 20.4477 16 21 16H61C61.5523 16 62 16.4477 62 17V27C62 27.5523 61.5523 28 61 28H21C20.4477 28 20 27.5523 20 27V17Z"
    />
    <path
      d="M20 33C20 32.4477 20.4477 32 21 32H61C61.5523 32 62 32.4477 62 33V43C62 43.5523 61.5523 44 61 44H21C20.4477 44 20 43.5523 20 43V33Z"
    />
    <path
      d="M0 0.999999C0 0.447714 0.447715 0 1 0H15C15.5523 0 16 0.447715 16 1V43C16 43.5523 15.5523 44 15 44H1C0.447715 44 0 43.5523 0 43V0.999999Z"
    />
    <path
      d="M66 0.999999C66 0.447714 66.4477 0 67 0H81C81.5523 0 82 0.447715 82 1V43C82 43.5523 81.5523 44 81 44H67C66.4477 44 66 43.5523 66 43V0.999999Z"
    />
  </svg>
</template>

<script>
export default {
  name: "ActiveTableLayoutIcon",
};
</script>
